import { Menu } from "react-admin";

export const MyMenu = () => (
    <Menu>
        <Menu.ResourceItem name="admin/ceres_users" />
        <Menu.ResourceItem name="admin/invite_requests" />
    </Menu>
);
